import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_ACTION_ITEM_DYNAMIC_FORM_STATE,
  FETCH_ACTION_ITEM_DYNAMIC_FORM_LIST_PROGRESS,
  FETCH_ACTION_ITEM_DYNAMIC_FORM_LIST_SUCCESS,
  FETCH_ACTION_ITEM_DYNAMIC_FORM_LIST_FAILED,
} from "./actionItemDynamicFormActions";
import { initialActionItemDynamicForms } from "./defaultState";
import { IActionItemDynamicForms } from "./actionItemDynamicForm.types";
import { ActionItemDynamicFormActions } from ".";

export const actionItemDynamicFormReducer = (
  state: IStoreState["actionItemDynamicForms"] = initialActionItemDynamicForms,
  action: ActionItemDynamicFormActions,
) => {
  switch (action.type) {
    case FETCH_ACTION_ITEM_DYNAMIC_FORM_LIST_PROGRESS: {
      return produce(state, (draftState: IActionItemDynamicForms) => {
        draftState.list.loading = LoadState.InProgress;
      });
    }
    case FETCH_ACTION_ITEM_DYNAMIC_FORM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState: IActionItemDynamicForms) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
    }
    case FETCH_ACTION_ITEM_DYNAMIC_FORM_LIST_FAILED: {
      return produce(state, (draftState: IActionItemDynamicForms) => {
        draftState.list.loading = LoadState.Failed;
      });
    }
    case CLEAR_ACTION_ITEM_DYNAMIC_FORM_STATE: {
      return initialActionItemDynamicForms;
    }
    default:
      return state;
  }
};
